import { Button, Col, DatePicker, Form, Row, Select, Space } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { useLoaderData, useOutletContext } from 'react-router-dom';
import useSettingsAPI from '../apis/settingAPI';
import { ACCOUNTING_URL } from '../../utils/axios';




const Settings = () => {
  const settings = useLoaderData();
  const [form] = Form.useForm();
  const { save, update } = useSettingsAPI();
  const [taxes, setTaxes] = useState([]);
  
  const handleSave = () => {
    let info = form.getFieldsValue();
    let keys = Object.keys(info);
    let data = [];
    keys.forEach((key, idx) => {
      let obj = {name: key, data: info[key]};
      data.push(obj);
    });
    // console.log(data);
    update(data);
  }
  // console.log(settings)
  useEffect(() => {
    fetch(ACCOUNTING_URL+'/taxes/all/sales-taxes')
    .then(res => res.json())
    .then(res => setTaxes(res))
    .catch(err => console.log(err))
  });
  // console.log(taxes)
  return (
    <div className='container mx-auto' style={{maxWidth: '1200px'}}>
      <Button onClick={handleSave} className='mb-3'>Save</Button>
      <Form form={form} initialValues={settings} variant='borderless' labelCol={{span: 8}} labelWrap={true} labelAlign='left' className='bg-white '>
        <Row>
          <Badge className="text-black-900 font-bold bg-gray-100 rounded-none text-md w-full">Taxes</Badge>
          <Col md={{span: 12}} className='p-3'>
            <Badge className="text-gray-600 p-0 font-bold bg-transparent rounded-none text-md w-full">Default Sales Tax</Badge>

            <Form.Item name={['taxes', 'sales_tax']} className='mb-1 font-semibold'>
              <Select name={'sales_tax'} options={taxes.map(tax => ({value: tax._id, label: tax.name}))} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default Settings;